/* Enhancements only loaded by The Commons full product page. Dawn owns commerce. */
if (!customElements.get('deep-commons-details')) {
  customElements.define('deep-commons-details', class extends HTMLElement {
    connectedCallback() {
      this.root = this.closest('[data-deep-commons]');
      if (!this.root) return;
      this.status = document.createElement('span');
      this.status.className = 'visually-hidden';
      this.status.setAttribute('role', 'status');
      this.after(this.status);
      this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
        if (data.sectionId !== this.dataset.section) return;
        const source = data.html.querySelector('deep-commons-details');
        if (!source) return;
        this.innerHTML = source.innerHTML;
        this.dataset.variantId = String(data.variant.id);
        this.status.textContent = `Selected ${data.variant.title}. Edition details updated.`;
      });
      this.viewer = this.root.querySelector('media-gallery slider-component');
      if (!this.viewer) return;
      this.onSlide = event => this.activate(event.detail.currentElement);
      this.onActive = event => this.activate(event.detail.activeMedia);
      this.viewer.addEventListener('slideChanged', this.onSlide);
      this.viewer.addEventListener('deep:active-media', this.onActive);
      this.activate(this.viewer.querySelector('.is-active') || this.viewer.querySelector('.slider__slide'));
    }
    activate(active) {
      if (!active) return;
      this.viewer.querySelectorAll('.slider__slide').forEach(slide => {
        const visible = slide === active;
        slide.inert = !visible;
        slide.classList.toggle('is-active', visible);
        if (!visible) slide.querySelectorAll('video').forEach(video => video.pause());
      });
    }
    disconnectedCallback() {
      this.unsubscribe?.();
      this.status?.remove();
      this.viewer?.removeEventListener('slideChanged', this.onSlide);
      this.viewer?.removeEventListener('deep:active-media', this.onActive);
    }
  });
}
if (!customElements.get('deep-commons-isbn')) {
  customElements.define('deep-commons-isbn', class extends HTMLElement {
    connectedCallback() {
      this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
        const root = document.querySelector('[data-deep-commons]');
        if (!root || root.dataset.section !== data.sectionId) return;
        const binding = data.variant.title.includes('Hardcover') ? 'hardcover' : 'paperback';
        this.querySelectorAll('[data-commons-isbn]').forEach(item => {
          item.hidden = item.dataset.commonsIsbn !== binding;
        });
      });
    }
    disconnectedCallback() { this.unsubscribe?.(); }
  });
}
if (!customElements.get('deep-commons-purchase')) {
  customElements.define('deep-commons-purchase', class extends HTMLElement {
    async connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.controller = new AbortController();
      const timeout = setTimeout(() => this.controller.abort(), 8000);
      try {
        const url = new URL(this.dataset.productUrl, location.origin);
        url.searchParams.set('section_id', 'deep-commons-purchase');
        url.searchParams.set('_purchase', crypto.randomUUID());
        const response = await fetch(url, { cache: 'no-store', signal: this.controller.signal });
        if (!response.ok) return;
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const content = html.querySelector('[data-commons-purchase-content]');
        if (!content || !this.isConnected) return;
        this.innerHTML = content.innerHTML;
        this.querySelector('button')?.addEventListener('click', () => { this.hidden = true; });
        this.hidden = false;
      } catch {
        // A missing snapshot or failed request must never block shopping.
      } finally {
        clearTimeout(timeout);
      }
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}
